export default {
  fi: {
    UserEditScene: {
      editInformation: 'Muokkaa tietoja',
    },
  },
};
